var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"score-wrapper"},[_c('div',{staticClass:"score-box bg-color-black"},[_c('div',{staticClass:"title"},[_vm._v("面试情况")]),_c('div',{staticClass:"desc"},[_vm._v("该生面试题目的分数情况")]),_c('div',{staticClass:"chart-box"},[_c('div',{ref:"line",staticStyle:{"width":"100%","height":"250px"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }